import ReferencesPage from './References.page';

export default ReferencesPage;
